import React, { useEffect, useState } from "react";

export default function PersonalDetails({ report }) {
  const formatDate = (dateString) => {
    if (!dateString) return "-";

    const [year, month, day] = dateString.split("+")[0].split("-");

    // Return in DD/MM/YYYY format for the CIBIL UI
    return `${day}/${month}/${year}`;
  };
  // Mock data matching the exact provided images
  const consumerInfo = {
    name: report?.personal?.name || "N/A",
    dob: formatDate(report?.personal?.dob) || "N/A",
    gender: report?.personal?.gender || "N/A",
    score: report?.score.value || "N/A",
  };

  const identifications = [
    {
      type: "PAN CARD",
      number: report?.personal?.pan || "N/A",
      issue: "-",
      expiry: "-",
    },
    // { type: 'VOTER ID', number: 'DTV3322138', issue: '-', expiry: '-' },
    // { type: "DRIVER'S LICENSE NO", number: 'RJ20DLC2005115853', issue: '-', expiry: '-' },
    {
      type: "RATION CARD NO",
      number: report?.personal?.rationCard || "N/A",
      issue: "-",
      expiry: "-",
    },
    // { type: 'AADHAAR ID', number: 'NOT DISCLOSED', issue: '-', expiry: '-' },
    {
      type: "CKYC",
      number: report?.personal?.ckyc || "N/A",
      issue: "-",
      expiry: "-",
    },
  ];

  const telephones = [
    { type: "Mobile Phone", number: "7689029872", ext: "-" },
    { type: "Not Classified", number: "007447737734463", ext: "-" },
    { type: "Office Phone", number: "000007442381938", ext: "-" },
    { type: "Home Phone", number: "007447737734463", ext: "-" },
  ];

  const [phones, setPhones] = useState([]);

  useEffect(() => {
    if (!report?.personal?.allPhones) return;

    const phoneList = report.personal.allPhones.map((element) => ({
      type:
        element?.PhoneType?.symbol === "01"
          ? "Mobile Phone"
          : "Home/Office Phone",
      number: element?.PhoneNumber?.Number,
      ext: "-",
    }));

    setPhones(phoneList);
  }, [report?.personal?.allPhones]);

  const emails = [report?.personal?.email];

  const addresses = report?.personal?.allAddresses

  const employments = report?.employment

  return (
    <div className="w-full max-w-5xl p-6 bg-white custom-font text-gray-900 print:p-0">
      {/* CONSUMER DETAILS HEADER */}
      <h2 className="text-lg font-bold text-gray-800 mb-4 uppercase tracking-wide">
        CONSUMER DETAILS
      </h2>

      {/* 1. CONSUMER INFORMATION SECTION */}
      <div className="mb-8">
        <h3 className="text-[14px] font-bold text-gray-800 mb-1.5 uppercase tracking-wide">
          CONSUMER INFORMATION
        </h3>
        <div className="border border-gray-400 rounded-[4px] p-4 flex justify-between items-center text-[11px] tracking-wide">
          <div className="flex gap-2">
            <span className="text-[#00a1de] font-bold uppercase">
              CONSUMER NAME :
            </span>
            <span className="text-black font-bold uppercase">
              {consumerInfo.name}
            </span>
          </div>
          <div className="flex gap-2">
            <span className="text-[#00a1de] font-bold uppercase">D.O.B :</span>
            <span className="text-black font-bold uppercase">
              {consumerInfo.dob}
            </span>
          </div>
          <div className="flex gap-2">
            <span className="text-[#00a1de] font-bold uppercase">GENDER :</span>
            <span className="text-black font-bold">{consumerInfo.gender}</span>
          </div>
          <div className="flex gap-2">
            <span className="text-[#00a1de] font-bold uppercase">
              CREDITVISION<sup className="font-medium text-[8px]">®</sup> SCORE
              :
            </span>
            <span className="text-black font-bold">{consumerInfo.score}</span>
          </div>
        </div>
      </div>

      {/* 2. IDENTIFICATION(S) SECTION */}
      <div className="mb-8">
        <h3 className="text-[14px] font-bold text-gray-800 mb-1.5 uppercase tracking-wide">
          IDENTIFICATION(S)
        </h3>
        <div className="border border-gray-400 rounded-[4px] overflow-hidden mb-1">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-gray-300 bg-white">
                <th className="px-4 py-2.5 text-[10px] font-bold text-[#00a1de] uppercase w-1/4">
                  IDENTIFICATION TYPE
                </th>
                <th className="px-4 py-2.5 text-[10px] font-bold text-[#00a1de] uppercase w-1/4">
                  IDENTIFICATION NUMBER
                </th>
                <th className="px-4 py-2.5 text-[10px] font-bold text-[#00a1de] uppercase w-1/4">
                  ISSUE DATE
                </th>
                <th className="px-4 py-2.5 text-[10px] font-bold text-[#00a1de] uppercase w-1/4">
                  EXPIRATION DATE
                </th>
              </tr>
            </thead>
            <tbody>
              {identifications.map((id, index) => (
                <tr
                  key={index}
                  className="odd:bg-[#f7f8fa] even:bg-white border-b border-gray-200 last:border-0"
                >
                  <td className="px-4 py-3 text-[11px] font-bold text-black uppercase">
                    {id.type}
                  </td>
                  <td className="px-4 py-3 text-[11px] font-bold text-black uppercase">
                    {id.number}
                  </td>
                  <td className="px-4 py-3 text-[11px] font-bold text-black">
                    {id.issue}
                  </td>
                  <td className="px-4 py-3 text-[11px] font-bold text-black">
                    {id.expiry}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-[11px] font-bold text-gray-500 ml-1">
          (e) - IDENTIFICATION REPORTED FROM ENQUIRY
        </div>
      </div>

      {/* 3. TELEPHONE(S) SECTION */}
      <div className="mb-8">
        <h3 className="text-[14px] font-bold text-gray-800 mb-1.5 uppercase tracking-wide">
          TELEPHONE(S)
        </h3>
        <div className="border border-gray-400 rounded-[4px] overflow-hidden mb-1">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-gray-300 bg-white">
                <th className="px-4 py-2.5 text-[10px] font-bold text-[#00a1de] uppercase w-1/3">
                  TYPE
                </th>
                <th className="px-4 py-2.5 text-[10px] font-bold text-[#00a1de] uppercase w-1/3">
                  TELEPHONE NUMBER
                </th>
                <th className="px-4 py-2.5 text-[10px] font-bold text-[#00a1de] uppercase w-1/3">
                  TELEPHONE EXTENSION
                </th>
              </tr>
            </thead>
            <tbody>
              {phones.map((tel, index) => (
                <tr
                  key={index}
                  className="odd:bg-[#f7f8fa] even:bg-white border-b border-gray-200 last:border-0"
                >
                  <td className="px-4 py-3 text-[11px] font-bold text-black">
                    {tel.type}
                  </td>
                  <td className="px-4 py-3 text-[11px] font-bold text-black">
                    {tel.number}
                  </td>
                  <td className="px-4 py-3 text-[11px] font-bold text-black">
                    {tel.ext}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-[11px] font-bold text-gray-500 ml-1">
          (e) - TELEPHONE REPORTED FROM ENQUIRY
        </div>
      </div>

      {/* 4. EMAIL CONTACT(S) SECTION */}
      <div className="mb-8">
        <h3 className="text-[14px] font-bold text-gray-800 mb-1.5 uppercase tracking-wide">
          EMAIL CONTACT(S)
        </h3>
        <div className="border border-gray-400 rounded-[4px] overflow-hidden">
          <table className="w-full text-left border-collapse">
            <tbody>
              {emails.map((email, index) => (
                <tr
                  key={index}
                  className="odd:bg-white even:bg-[#f7f8fa] border-b border-gray-200 last:border-0"
                >
                  <td className="px-4 py-3 text-[11px] font-bold text-black uppercase">
                    {email}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 5. CONSUMER'S REPORTED ADDRESS(ES) SECTION */}
      <div className="mb-8">
        <h3 className="text-[14px] font-bold text-gray-800 mb-1.5 uppercase tracking-wide">
          CONSUMER'S REPORTED ADDRESS(ES)
        </h3>
        <div className="border border-gray-400 rounded-[4px] overflow-hidden mb-1">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-gray-300 bg-white">
                <th className="px-4 py-2.5 text-[10px] font-bold text-[#00a1de] uppercase w-[50%]">
                  ADDRESS
                </th>
                <th className="px-4 py-2.5 text-[10px] font-bold text-[#00a1de] uppercase w-[20%]">
                  CATEGORY
                </th>
                <th className="px-4 py-2.5 text-[10px] font-bold text-[#00a1de] uppercase w-[15%]">
                  RESIDENCE CODE
                </th>
                <th className="px-4 py-2.5 text-[10px] font-bold text-[#00a1de] uppercase w-[15%]">
                  DATE REPORTED
                </th>
              </tr>
            </thead>
            <tbody>
              {addresses.map((addr, index) => (
                <tr
                  key={index}
                  className="odd:bg-white even:bg-[#f7f8fa] border-b border-gray-200 last:border-0"
                >
                  <td className="px-4 py-4 text-[11px] font-bold text-black uppercase leading-relaxed pr-8">
                    {addr?.CreditAddress?.StreetAddress || "N/A"}
                  </td>
                  <td className="px-4 py-4 text-[11px] font-bold text-black">
                    {addr?.category || "N/A"}
                  </td>
                  <td className="px-4 py-4 text-[11px] font-bold text-black">
                    {addr?.CreditAddress?.PostalCode || "N/A"}
                  </td>
                  <td className="px-4 py-4 text-[11px] font-bold text-black">
                    {addr?.dateReported || "N/A"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-[11px] font-bold text-gray-500 ml-1">
          (e) - ADDRESSES REPORTED FROM ENQUIRY
        </div>
      </div>

      {/* 6. EMPLOYMENT INFORMATION SECTION */}
      <div className="mb-4">
        <h3 className="text-[14px] font-bold text-gray-800 mb-1.5 uppercase tracking-wide">
          EMPLOYMENT INFORMATION
        </h3>
        <div className="border border-gray-400 rounded-[4px] overflow-hidden">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-gray-300 bg-white">
                <th className="px-4 py-2.5 text-[10px] font-bold text-[#00a1de] uppercase w-1/5">
                  ACCOUNT TYPE
                  <br />
                  <span className="text-[9px] lowercase capitalize font-normal leading-tight">
                    (Date Reported)
                  </span>
                </th>
                <th className="px-4 py-2.5 text-[10px] font-bold text-[#00a1de] uppercase w-1/5">
                  OCCUPATION TYPE
                </th>
                <th className="px-4 py-2.5 text-[10px] font-bold text-[#00a1de] uppercase w-1/5">
                  INCOME
                </th>
                <th className="px-4 py-2.5 text-[10px] font-bold text-[#00a1de] uppercase w-1/5">
                  NET/GROSS INCOME INDICATOR
                </th>
                <th className="px-4 py-2.5 text-[10px] font-bold text-[#00a1de] uppercase w-1/5">
                  MONTHLY/ANNUAL INCOME INDICATOR
                </th>
              </tr>
            </thead>
            <tbody>
                <tr
                  className="odd:bg-[#f7f8fa] even:bg-white border-b border-gray-200 last:border-0"
                >
                  <td className="px-4 py-4 text-[11px] font-bold text-black uppercase">
                    {employments?.accountType || "N/A"}
                    <div className="text-[10px] text-gray-600 mt-0.5">
                      {formatDate(employments?.dateReported) || "N/A"}
                    </div>
                  </td>
                  <td className="px-4 py-4 text-[11px] font-bold text-black">
                    {employments?.OccupationCode?.description || "N/A"}
                  </td>
                  <td className="px-4 py-4 text-[11px] font-bold text-black">
                    {employments?.income || "N/A"}
                  </td>
                  <td className="px-4 py-4 text-[11px] font-bold text-black">
                    {employments?.netGross || "N/A"}
                  </td>
                  <td className="px-4 py-4 text-[11px] font-bold text-black">
                    {employments?.monthlyAnnual  || "N/A"}
                  </td>
                </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
